import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const $elem = $('.project-milestone');

$(function () {
    if ($elem.length > 0) {
        $elem.each(function () {
            bindEvents($(this));
        });
    }
});

const bindEvents = (element) => {
    const $content = element.find('.project-milestone__content');

    renderAxis(element);
    contentOverflow($content);
    $content.on('scroll', function () {
        contentOverflow($content);
    });
    $window.on(
        'resize:width',
        debounce(function () {
            renderAxis(element);
            contentOverflow($content);
        })
    );
};

const renderAxis = (element) => {
    const $axis = element.find('.project-milestone__axis');
    const count = Math.floor($axis.outerWidth() / 50);

    $axis.html('');
    for (let i = 0; i < count; i++) {
        $axis.append('<div class="project-milestone__dot"></div>');
    }
};

const contentScrolledLeft = (element) => element.scrollLeft() === 0;
const contentScrolledRight = (element) => Math.ceil(element.scrollLeft() + element.outerWidth()) >= Math.ceil(element[0].scrollWidth);

const contentOverflow = (element) => {
    const $parent = element.parent();

    if (contentScrolledLeft(element) && contentScrolledRight(element)) {
        $parent.addClass('content-is-left content-is-right');
    } else {
        if (contentScrolledLeft(element)) {
            $parent.addClass('content-is-left');
        } else {
            $parent.removeClass('content-is-left');
        }

        if (contentScrolledRight(element)) {
            $parent.addClass('content-is-right');
        } else {
            $parent.removeClass('content-is-right');
        }
    }
};
